"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMenuControls = exports.MenuControlsContext = void 0;
var react_1 = require("react");
exports.MenuControlsContext = (0, react_1.createContext)(undefined);
function useMenuControls() {
    return (0, react_1.useContext)(exports.MenuControlsContext);
}
exports.useMenuControls = useMenuControls;
